export const qualification = {
    labels: {
        qualification: "Qualification",
        qualifications: "Qualifications",
        qualifications_group: "Qualifications - Categories",
        qualification_edit: "Qualifications - Edit Category",
        categories: "Categories",
        category: "Category",
    },
    placeholders: {
    },
    modals: {
        titles: {
            qualification_add: "Add Qualification",
            qualification_del: "Delete Qualification",
            category_add: "Add Category",
            category_del: "Delete Category",
        },
        messages: {
            category_del: "Are you sure you want to remove the category <strong>{name}</strong>?<br/>This will remove all qualifications in this group.",
            qualification_del: "Are you sure you want to remove the qualification <strong>{name}</strong>?<br/>This action cannot be undone!",
        },
    },
    texts: {
    },
};
